import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import FiltersService from 'cio/services/filters';
import DS from 'ember-data';

export default class SubjectRoute extends Route {
  @service filters!: FiltersService;
  @service store!: DS.Store;

  templateName = 'base/overview/subjects/subject';

  model(params: { subject_id: string }) {
    return this.store.findRecord('subject', params.subject_id);
  }

  afterModel() {
    return this.filters.process.perform();
  }
}
